import React from 'react';
import { Text, Icon } from 'porosys-ui';
import handleSeprateArrayContents from '../../../common/utils/print-array-contents';
import { Link } from 'react-router-dom';
import Card from '../../../common/ui/components/CardLayout/CardLayout';
import handlePrintStartEndTimeOfMetting from '../../../common/helpers/print-meeting-time-range';

const MeetingCard = props => {
    const { meeting, meetingsAcl, handleEditMeeting, handleDeleteMeeting } = props;

    return (
        <Card
            classes={{ root: 'meeting-card' }}
            header={
                <>
                    <div className="flex">
                        <Link to={`meetings/${meeting?._id}`}>
                            <Text variant="subtitle1"> {meeting?.title} </Text>
                        </Link>
                        &nbsp;
                        <Text classes={{ root: 'text-muted' }} variant="subtitle2">
                            {' '}
                            {meeting?.meetingCode}{' '}
                        </Text>
                        <div className="spacer" />
                        <Icon name="clock" classes={{ root: 'text-muted' }} />
                        <div className="spacer lv-1" />
                        <Text classes={{ root: 'text-muted' }} variant="caption">
                            {handlePrintStartEndTimeOfMetting(meeting?.startAt, meeting?.endAt)}
                        </Text>
                    </div>
                    {meetingsAcl.edit && meetingsAcl.delete && (
                        <div className="actions-btn text-muted">
                            {meetingsAcl.edit && (
                                <button className="btn" onClick={() => handleEditMeeting(meeting)}>
                                    <Icon fontSize={1} name="pen" />{' '}
                                </button>
                            )}
                            {meetingsAcl.delete && (
                                <button className="btn delete-button" onClick={() => handleDeleteMeeting(meeting?._id)}>
                                    <Icon fontSize={1} name="trash" />
                                </button>
                            )}
                        </div>
                    )}
                </>
            }
            content={
                <div>
                    <Text>
                        <Icon name="users" /> {handleSeprateArrayContents('fullname', meeting?.participants)}
                    </Text>
                    <div className="flex space-around">
                        {/* <div className="labels">
            <Tag
                tooltip="'The Minutes Form' hasn't submitted since 5 days ago"
                color="#da1212"
            />
            <Tag tooltip="'The Minutes Form' isn't completed yet" color="#ebeb3f" />
            <Tag tooltip="Add your signiture to minutes form" color="#707070" />
        </div> */}
                    </div>
                </div>
            }
        ></Card>
    );
};

export default MeetingCard;
